import { Component } from "react"
import PropTypes from "prop-types"

import appletOrConnectionPath from "app/scripts/applet_or_connection_path"
import { connectionShape } from "app/lib/shared_prop_types"
import logIFTTTNextAction from "app/lib/ifttt_next_log_action"
import SmallAppletCard from "shared/components/applet_card/ifttt_next/small_applet_card"

export default class AppletCard extends Component {
  defaultTracking = {
    location_type: "my_applets",
    connection_status: this.props.applet.status,
    object_id: this.props.applet.id,
    object_type: "connection",
  }

  handleOnClick = () => {
    logIFTTTNextAction(
      "click",
      this.props.clickTracking || this.defaultTracking
    )
  }

  render() {
    const applet = this.props.applet
    return (
      <li
        className="my-web-applet-card web-applet-card"
        id={`applet-${applet.id}`}
      >
        <SmallAppletCard
          appletPath={appletOrConnectionPath(applet)}
          onAppletClick={this.handleOnClick}
          applet={applet}
        />
      </li>
    )
  }
}

AppletCard.propTypes = {
  applet: connectionShape,
  clickTracking: PropTypes.object,
}
